var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.breadcrumb),function(txt,idx){return _c('a',{key:txt+idx,on:{"click":function($event){return _vm.handleClick(txt, idx)}}},[_vm._v(" "+_vm._s(txt)+" "),(idx < (_vm.breadcrumb.length-1))?_c('v-icon',[_vm._v("mdi-chevron-right")]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }